import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Space } from 'antd';
import { OD_MAP_TYPES } from '../../../constants/odMap';
import { useAggregationConfig } from '../../../hooks/SimViewer/useAggregationConfig';
import { useDataFilter } from '../../../hooks/SimViewer/useDataFilter';
import { useOdMapConfig } from '../../../hooks/SimViewer/useOdMapConfig';
import { MapMarkedIconButton } from '../../MapMarkedIconButton';

type Props = {
  icon: ReactNode;
  label: string;
  extra?: ReactNode;
};

const OdMapPanel = ({ icon, label, extra }: Props): ReactNode => {
  const { aggregationConfig, startAggregation, clearAggregation } =
    useAggregationConfig();
  const { setOdMapType } = useOdMapConfig();
  const { dataFilter } = useDataFilter();
  const { t } = useTranslation();

  const isActive =
    aggregationConfig?.target === 'od_map' &&
    aggregationConfig?.type === 'od_map';

  return (
    <Collapse.Panel
      key="od_map"
      header={
        <Space>
          {icon}
          {label}
          {extra}
        </Space>
      }
      extra={
        <MapMarkedIconButton
          active={isActive}
          onClick={(): void => {
            if (isActive) {
              clearAggregation();
            } else {
              startAggregation('od_map');

              if (dataFilter.pass.wayIds.length > 0) {
                setOdMapType(OD_MAP_TYPES.MESH_1KM);
              } else {
                setOdMapType(OD_MAP_TYPES.MESH_125M);
              }
            }
          }}
          disabled={
            dataFilter.start.areaKeyCodes.length === 0 &&
            dataFilter.end.areaKeyCodes.length === 0 &&
            dataFilter.start.customAreaKeys.length === 0 &&
            dataFilter.end.customAreaKeys.length === 0 &&
            dataFilter.pass.wayIds.length === 0
          }
          messageDisabled={t('message.odMapUnavailable')}
        />
      }
    />
  );
};

export { OdMapPanel };
